<template>
  <div class="todo-container">
    <div class="task-input">
      <a-input v-model="newTask" placeholder="+ 添加任务至「收集箱」" class="task-name-input" @pressEnter="addTask">
        <template #addonAfter>
          <a-date-picker v-model="newTaskDeadline" :show-time="{ format: 'HH:mm' }" format="MM-DD HH:mm" placeholder="选择截止时间" class="deadline-picker" />
          <a-button type="link" class="today-btn">
            <a-icon type="calendar" />
            今天
          </a-button>
        </template>
      </a-input>
    </div>

    <!-- 未完成任务组 -->
    <div v-if="incompleteTasks.length > 0" class="task-group">
      <div class="group-header">
        <div class="group-title">
          <a-icon type="caret-down" />
          <span>未完成 {{ incompleteTasks.length }}</span>
        </div>
      </div>
      <div class="task-list">
        <div v-for="task in incompleteTasks" :key="task.id" class="task-item" :class="{ completed: task.completed }">
          <div class="task-checkbox">
            <a-checkbox :checked="task.completed" @change="() => toggleTask(task.id)" />
          </div>
          <div class="task-content">
            <span class="task-name">{{ task.name }}</span>
            <div class="task-tags">
              <a-tag v-if="isOverdue(task.deadline)" color="#ff4d4f"> 过期{{ getOverdueDays(task.deadline) }}天 </a-tag>
              <a-tag v-else :color="getStatusColor(task.status)">
                {{ formatDeadline(task.deadline) }}
              </a-tag>
              <a-tag :color="getStatusColor(task.status)">{{ task.status }}</a-tag>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 已完成任务组 -->
    <div v-if="completedTasks.length > 0" class="task-group">
      <div class="group-header">
        <div class="group-title">
          <a-icon type="caret-down" />
          <span>已完成 {{ completedTasks.length }}</span>
        </div>
      </div>
      <div class="task-list">
        <div v-for="task in completedTasks" :key="task.id" class="task-item completed">
          <div class="task-checkbox">
            <a-checkbox :checked="task.completed" @change="() => toggleTask(task.id)" />
          </div>
          <div class="task-content">
            <div class="task-name">{{ task.name }}</div>
            <div class="task-info">
              <span class="create-time">{{ task.createTime }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TodoList',
  data() {
    return {
      newTask: '',
      newTaskDeadline: null,
      tasks: [
        {
          id: 1,
          name: '排查流程部署完成后没有执行集成自动化用例',
          completed: false,
          status: '收集箱',
          deadline: moment().subtract(2, 'days').valueOf() // 示例：2天前的时间戳
        },
        {
          id: 2,
          name: '新服务创建自动化流程梳理',
          completed: false,
          status: '待办事项',
          tag: '过期2天'
        },
        {
          id: 3,
          name: '自动发布梳理',
          completed: false,
          status: '待办事项',
          tag: '过期2天'
        },
        {
          id: 4,
          name: '找殷毅沟通自动发布需求',
          completed: true,
          createTime: '4月15日',
          status: '待办事项',
          tag: '过期2天'
        }
      ]
    };
  },
  computed: {
    incompleteTasks() {
      return this.tasks.filter(task => !task.completed);
    },
    completedTasks() {
      return this.tasks.filter(task => task.completed);
    }
  },
  methods: {
    addTask() {
      if (!this.newTask.trim()) return;

      const newTask = {
        id: Date.now(),
        name: this.newTask.trim(),
        completed: false,
        status: '收集箱',
        deadline: this.newTaskDeadline ? this.newTaskDeadline.valueOf() : null,
        createTime: moment().format('M月D日')
      };

      this.tasks = [...this.tasks, newTask];
      this.newTask = '';
      this.newTaskDeadline = null;
    },
    toggleTask(taskId) {
      const taskIndex = this.tasks.findIndex(t => t.id === taskId);
      if (taskIndex > -1) {
        const updatedTask = { ...this.tasks[taskIndex] };
        updatedTask.completed = !updatedTask.completed;

        this.tasks.splice(taskIndex, 1, updatedTask);
      }
    },
    isOverdue(deadline) {
      if (!deadline) return false;
      return moment(deadline).isBefore(moment(), 'day');
    },
    getOverdueDays(deadline) {
      return moment().diff(moment(deadline), 'days');
    },
    formatDeadline(deadline) {
      if (!deadline) return '';
      return moment(deadline).format('MM-DD HH:mm');
    },
    getStatusColor(status) {
      const colors = {
        收集箱: '#8c8c8c',
        待办事项: '#1890ff',
        缺陷处理: '#722ed1'
      };
      return colors[status] || 'default';
    }
  }
};
</script>

<style lang="less" scoped>
.todo-container {
  padding: 20px;

  .task-input {
    margin-bottom: 16px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);

    .task-name-input {
      .ant-input {
        border-radius: 8px 0 0 8px;
      }

      .ant-input-group-addon {
        padding: 0;
        border: none;
        background: #fafafa;
        border-radius: 0 8px 8px 0;

        .deadline-picker {
          width: 150px;
          margin-right: 8px;
        }

        .today-btn {
          color: #1890ff;
          margin-right: 8px;

          .anticon {
            margin-right: 4px;
          }
        }
      }
    }
  }

  .task-group {
    margin-bottom: 24px;

    .group-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      padding: 0 4px;

      .group-title {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #595959;
        font-size: 13px;

        .anticon {
          font-size: 12px;
        }
      }

      .delay-btn {
        color: #1890ff;
        font-size: 13px;
        padding: 0;
        height: auto;
      }
    }

    .task-list {
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
      overflow: hidden;

      .task-item {
        display: flex;
        align-items: flex-start;
        padding: 8px 12px;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background: #fafafa;
        }

        &.completed {
          background: #fafafa;

          .task-name {
            color: #bfbfbf;
            text-decoration: line-through;
          }
        }

        .task-checkbox {
          padding-top: 2px;
          margin-right: 8px;
        }

        .task-content {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 4px 0;

          .task-name {
            flex: 1;
            margin-right: 16px;
            color: #262626;
            font-size: 14px;
            line-height: 1.4;
          }

          .task-tags {
            display: flex;
            gap: 6px;
            flex-shrink: 0;

            .ant-tag {
              margin-right: 0;
              font-size: 12px;
              line-height: 20px;
              padding: 0 8px;
            }
          }
        }
      }
    }
  }
}
</style>
